module.exports = __webpack_public_path__ + "b69fd6b57131474dc58f761524d764f4.png";